import { render, staticRenderFns } from "./SetupVideoSlot.vue?vue&type=template&id=4e446518&scoped=true"
import script from "./SetupVideoSlot.vue?vue&type=script&lang=js"
export * from "./SetupVideoSlot.vue?vue&type=script&lang=js"
import style0 from "./SetupVideoSlot.vue?vue&type=style&index=0&id=4e446518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e446518",
  null
  
)

export default component.exports